import { Link } from "react-router-dom";
import skillOffer from "../../../src/svg/skill.svg";
import PropTypes from "prop-types";
import { SERVER_URL } from "../../config";

const LeftBase = (props) => {
  const { showBackto } = props
  const handleBack = (e) => {
    e.preventDefault();
    window.location.href = SERVER_URL
  }
  
  return (
    <div className="left-base-container">
      <div className="">
        <p className="text-white text-decoration-none">
          <p className="text-start mt-3 px-4">
            {showBackto && <Link to={SERVER_URL} onClick={(e) => handleBack(e)} className="text-white text-decoration-none backTitle"><i className="fa fa-arrow-left me-1"></i> Back to Home</Link>}
          </p>
        </p>
        <img src={skillOffer} alt="skill offer" className="p-3 mt-260 w-100" />
        <div className="text-start text-white w-100 m-auto py-2 px-3">
          <p className="description">Forget the old rules. Join the largest network of independent professionals. Find great work. <span className="f-600">Your terms, Your time.</span>
          </p>
        </div>
      </div>
    </div>
  )
}
LeftBase.propTypes = {
  showBackto: PropTypes.bool,
};

LeftBase.defaultProps = {
  showBackto: true
};

export default LeftBase
